import { useSelector } from 'react-redux';

const isTrue = (v) => String(v || '').toLowerCase() === 'true';

/**
 * ExtraMilePlay logo + Back button, top-left on every screen (same header as the
 * Modak Marathon game). Inside the mobile app the Back button is hidden and the
 * logo asks the app to navigate back instead.
 */
export default function ManorHeader() {
  const session = useSelector((s) => s.manor.session);
  const logo = session?.companyLogoUrl || process.env.REACT_APP_EM_LOGO;
  const home = process.env.REACT_APP_BASE_URL;
  const backUrl = session?.backButtonRedirect || home;
  const fromApp = isTrue(session?.fromMobileApp);

  const onLogo = (e) => {
    if (!fromApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.('navigate_back');
  };

  return (
    <header className="manor-header">
      <a href={home} onClick={onLogo}>
        {logo && <img src={logo} className="manor-logo" alt="Extramile Play" />}
      </a>
      {!fromApp && (
        <div className="manor-back-holder">
          <a href={backUrl}>
            <button type="button" className="manor-back-btn">Back</button>
          </a>
        </div>
      )}
    </header>
  );
}
